import type { SVGProps } from 'react';
const SvgIconBolt = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m9.179 3.24-5.8 5.51H7.5a.75.75 0 0 1 .681 1.064l-1.36 2.946 5.8-5.51H8.5a.75.75 0 0 1-.681-1.064zm-.087-1.986c.998-.95 2.573.179 1.995 1.43L9.672 5.75h3.576c1.129 0 1.68 1.379.86 2.156l-7.2 6.84c-.998.95-2.573-.179-1.995-1.43l1.415-3.066H2.752c-1.129 0-1.68-1.379-.86-2.156z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconBolt;
